import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory, extractRelativeActionUrl } from './types';

export const demandFrameworkChangedDescriptor = defineNotificationCategory(
  'demand_framework_changed',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/intake/demands`,
    pills: () => ['Demand Views'],
    audience: PERMISSIONS.EDIT_DEMAND,
    scope: 'entity',
    defaultChannels: ['email', 'in_app', 'slack'],
  },
);

export const demandReviewerAssignedDescriptor = defineNotificationCategory(
  'demand_reviewer_assigned',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: () => ['Demand Views'],
    audience: PERMISSIONS.EVALUATE_DEMAND,
    scope: 'entity',
    defaultChannels: ['in_app'],
  },
);

export const demandStageChangedDescriptor = defineNotificationCategory('demand_stage_changed', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Demand Views'],
  audience: PERMISSIONS.EDIT_DEMAND,
  scope: 'entity',
  defaultChannels: ['in_app'],
});
